<template>
  <div class="container">
    <div class="titleBox">
      <div class="titleZh">{{ info.title }}</div>
      <div class="line"></div>
      <div class="titleEn">{{ info.title_en }}</div>
    </div>
    <div class="inforBox">
      <IScrollView>
        <div class="scroll-content">
          <div class="itemBox">
            <div class="scroll-item" v-for="(item,index) in info.infos" :key="index">
              <img class="scorllImg" :src="item.img">
              <div class="line"></div>
              <div class="scorllTitile">{{ item.title }}</div>
              <div class="scorllDesc">{{ item.desc }}</div>
            </div>
          </div>
        </div>
      </IScrollView>
    </div>
  </div>
</template>
<script>
import IScrollView from "@/components/content/iScrollView/IScrollView.vue";

export default {
  name: 'ScorllView',
  components: { IScrollView },
  props: {
    info: {
      type: Object, default() {
        return {}
      }
    },
  },
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.container {
  width: 1375px;
  border-radius: 24px;
  background-color: #E8EEFC;
  position: relative;
  box-sizing: border-box;

  .titleBox {
    box-sizing: border-box;
    background-color: #2A45A7;
    border-radius: 24px;
    position: absolute;
    top: -70px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    display: flex;
    align-items: center;
    height: 186px;

    .titleZh {
      overflow: hidden;
      margin: 0px 24px;
      margin-left: 32px;
      font-size: 32px;
      color: #EAFF74;
    }

    .line {
      width: 1px;
      height: 102px;
      opacity: 0.2;
      background-color: #FFFFFF;
    }

    .titleEn {
      margin: 0px 24px;
      margin-right: 32px;
      opacity: 0.5;
      font-size: 20px;
      color: #FFFFFF;
    }
  }

  .inforBox {
    .scroll-content {
      box-sizing: border-box;
      display: inline-block;
      padding: 164px 227px;
      padding-bottom: 54px;

      .itemBox {
        display: flex;

        .scroll-item {
          margin-right: 120px;

          .scorllImg {
            width: 401px;
            height: 279px;
            border-radius: 16px;
          }

          .line {
            margin-top: 47px;
            margin-bottom: 24px;
            width: 400px;
            height: 0px;
            opacity: 1;
            border: 4px solid #2A45A7;
          }

          .scorllTitile {
            white-space: break-spaces;
            text-align: left;
            font-size: 32px;
            font-family: "SourceHanSansSC-Heavy-2";
            font-weight: 800;
            color: #2A45A7;
            margin-bottom: 25px;
            width: 412px;
            white-space: pre-wrap;
          }

          .scorllDesc {
            white-space: break-spaces;
            width: 412px;
            text-align: left;
            font-size: 24px;
            font-family: "SourceHanSansSC-Medium-2";
            font-weight: 500;
            color: #24262B;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/ScorllView.vue